import { Reducer } from "redux";
import { message } from "antd";
import { BulkPaymentState, BulkPaymentTypes } from "./types";
import { AuthActionTypes } from "../auth";

export const initialState: BulkPaymentState = {
  error: undefined,
  failure: true,
  loading: false,
  pages: [],
  success: false,
  failed: false,
  isSubmitting: false,
  step: 1,
  fileId: 0,
  processing: false,
  filePreviewSuccess: false,
  providerName: "",
  providers: [],
  bulkpay: null,
  uploaded: false,
  files: [],
  filesTotal: 0,
  loadingFiles: false,
  uploadingFile: false,
  uploadSuccess: false,
  isApproving: false,
  approvalError: null,
  approvalSuccess: false,
  isRejecting: false,
  rejectError: null,
  rejectSuccess: false,
  checkResult: [],
  checkLoading: false,
  checkError: null,
  downloadingSampleFile: false,
  downloadSampleFileError: null,
  submitToCheckerError: null,
  submitToCheckerSuccess: false,
  isExporting: false,
  exportError: null,
};

const reducer: Reducer<BulkPaymentState> = (state = initialState, action) => {
  switch (action.type) {
    case AuthActionTypes.DESTROY_STATES:
      return initialState;
    case BulkPaymentTypes.GET_PROVIDERS_SUCCESS:
      return {
        ...state,
        providers: action.payload,
      };
    case BulkPaymentTypes.UPLOAD_FILE:
      return {
        ...state,
        loading: true,
        uploadingFile: true,
      };
    case BulkPaymentTypes.FILE_PREVIEW_REQUEST:
      return {
        ...state,
        error: {},

        processing: false,
      };
    case BulkPaymentTypes.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        error: {},
        uploaded: true,
        processing: false,
        loading: false,
        fileId: action.payload,
        uploadingFile: false,
        uploadSuccess: true,
      };
    case BulkPaymentTypes.UPLOAD_FILE_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        uploaded: false,
        failure: true,
        loading: false,
        uploadingFile: false,
        uploadSuccess: false,
      };
    case BulkPaymentTypes.UPLOAD_FILE_FAILED:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        uploaded: false,
        failed: true,
        loading: false,
        uploadingFile: false,
        uploadSuccess: false,
      };
    case BulkPaymentTypes.FILE_PREVIEW:
      return {
        ...state,
        pages: action.payload,
        error: {},

        processing: false,
        filePreviewSuccess: true,
      };
    case BulkPaymentTypes.INCREASE_BULK_PAYMENT_STEP:
      return {
        ...state,
        step: state.step + 1,
        processing: true,
        success: false,
      };
    case BulkPaymentTypes.DECREASE_BULK_PAYMENT_STEP:
      return {
        ...state,
        step: state.step - 1,
      };
    case BulkPaymentTypes.COMPLETE_PAYMENT_REQUEST:
      return {
        ...state,
        isSubmitting: true,
        error: {},
        success: false,
        failure: false,
      };
    case BulkPaymentTypes.COMPLETE_PAYMENT_SUCCESS:
      return {
        ...state,
        isSubmitting: false,
        bulkpay: action.payload,
        success: true,
        failure: false,
        // uploadSuccess: false,
        error: {},
      };
    case BulkPaymentTypes.COMPLETE_PAYMENT_FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: action.payload,
        success: false,
        failure: true,
      };
    case BulkPaymentTypes.CLEAR_STATES:
      return {
        ...state,
        isSubmitting: false,
        success: false,
        error: undefined,
        failure: false,
        failed: false,
        loading: false,
        processing: false,
        uploadSuccess: false,
        providers: [],
        pages: [],
        loadingFiles: false,
        files: [],
        filesTotal: 0,
        uploaded: false,
        isApproving: false,
        approvalError: null,
        approvalSuccess: false,
        isRejecting: false,
        rejectError: null,
        rejectSuccess: false,
        checkResult: [],
        checkLoading: false,
        checkError: null,
        downloadingSampleFile: false,
        downloadSampleFileError: null,
      };

    case BulkPaymentTypes.GET_BULKPAYMENT_FILES_REQUEST:
      return {
        ...state,
        loadingFiles: true,
        files: [],
        filesTotal: 0,
        error: undefined,
      };
    case BulkPaymentTypes.GET_BULKPAYMENT_FILES_SUCESS:
      return {
        ...state,
        loadingFiles: false,
        files: action.payload.files,
        filesTotal: action.payload.total,
      };
    case BulkPaymentTypes.GET_BULKPAYMENT_FILES_FAILURE:
      return {
        ...state,
        loadingFiles: false,
        files: [],
        filesTotal: 0,
        error: action.payload,
      };
      case BulkPaymentTypes.SUBMIT_TO_CHECKER_REQUEST:
        return {
          ...state,
          isSubmitting: true,
          submitToCheckerError: null, // Clear specific error
          submitToCheckerSuccess: false, // Clear specific success
        };
      
      case BulkPaymentTypes.SUBMIT_TO_CHECKER_SUCCESS:
        // message.success("Payment successfully submitted to checker");
        return {
          ...state,
          isSubmitting: false,
          submitToCheckerError: null,
          submitToCheckerSuccess: true, // Set specific success
        };
      
      case BulkPaymentTypes.SUBMIT_TO_CHECKER_FAILURE:
        return {
          ...state,
          isSubmitting: false,
          submitToCheckerError: action.payload, // Set specific error
          submitToCheckerSuccess: false,
        };
    case BulkPaymentTypes.APPROVE_BULK_PAYMENT_REQUEST:
      return {
        ...state,
        isApproving: true,
        approvalError: null,
        approvalSuccess: false,
      };
    case BulkPaymentTypes.APPROVE_BULK_PAYMENT_SUCCESS:
      // message.success("Bulk payment approved successfully");
      return {
        ...state,
        isApproving: false,
        approvalError: null,
        approvalSuccess: true,
      };
    case BulkPaymentTypes.APPROVE_BULK_PAYMENT_FAILURE:
      return {
        ...state,
        isApproving: false,
        approvalError: action.payload,
        approvalSuccess: false,
      };

    case BulkPaymentTypes.REJECT_BULK_PAYMENT_REQUEST:
      return {
        ...state,
        isRejecting: true,
        rejectError: null,
        rejectSuccess: false,
      };

    case BulkPaymentTypes.REJECT_BULK_PAYMENT_SUCCESS:
      return {
        ...state,
        isRejecting: false,
        rejectError: null,
        rejectSuccess: true,
      };

    case BulkPaymentTypes.REJECT_BULK_PAYMENT_FAILURE:
      return {
        ...state,
        isRejecting: false,
        rejectError: action.payload,
        rejectSuccess: false,
      };
    case BulkPaymentTypes.CLEAR_BULK_PAYMENT_STATES:
      return {
        ...state,
        isApproving: false,
        approvalSuccess: false,
        approvalError: null,
        isRejecting: false,
        rejectSuccess: false,
        rejectError: null,
        exportError: null,
        submitToCheckerError: null,
        submitToCheckerSuccess: false,
      };
    case BulkPaymentTypes.BULK_PAYMENT_CHECK_REQUEST:
      return {
        ...state,
        checkLoading: true,
        checkError: null,
        checkResult: [],
      };
    case BulkPaymentTypes.BULK_PAYMENT_CHECK_SUCCESS:
      return {
        ...state,
        checkLoading: false,
        checkResult: action.payload,
        checkError: null,
      };
    case BulkPaymentTypes.BULK_PAYMENT_CHECK_FAILURE:
      return {
        ...state,
        checkLoading: false,
        checkError: action.payload,
      };
    case BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_REQUEST:
      return {
        ...state,
        downloadingSampleFile: true,
        downloadSampleFileError: null,
      };
    case BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_SUCCESS:
      return {
        ...state,
        downloadingSampleFile: false,
        downloadSampleFileError: null,
      };
    case BulkPaymentTypes.DOWNLOAD_SAMPLE_FILE_FAILURE:
      return {
        ...state,
        downloadingSampleFile: false,
        downloadSampleFileError: action.payload,
      };
    case BulkPaymentTypes.BULK_PAYMENT_EXPORT_REQUEST:
      return {
        ...state,
        isExporting: true,
        exportError: null,
      };
    case BulkPaymentTypes.BULK_PAYMENT_EXPORT_SUCCESS:
      return {
        ...state,
        isExporting: false,
        exportError: null,
      };
    case BulkPaymentTypes.BULK_PAYMENT_EXPORT_FAILURE:
      return {
        ...state,
        isExporting: false,
        exportError: action.payload,
      };
    default:
      return state;
  }
};

export { reducer as bulkPaymentReducer };
